import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { Check, Link } from "lucide-react";

interface CopyLinkButtonProps {
  link: string;
  tooltipId?: string;
}

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({
  link,
  tooltipId = "copy-link-tooltip",
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
    } catch {}
  };

  const handleMouseLeave = () => {
    setCopied(false);
  };

  return (
    <>
      <button
        onClick={copyToClipboard}
        onMouseLeave={handleMouseLeave}
        className="opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
        data-tooltip-id={tooltipId}
        data-tooltip-content={copied ? t("Copied!") : t("Copy link")}
      >
        {copied ? (
          <div className="bg-green-600 p-1 rounded-full">
            <Check className="w-3 h-3 text-white" />
          </div>
        ) : (
          <Link className="w-4 h-4 text-gray-600" />
        )}
      </button>
      <Tooltip id={tooltipId} style={{ padding: "4px" }} />
    </>
  );
};

export default CopyLinkButton;
